module.exports = __webpack_public_path__ + "static/media/concretewall.660d401e.jpg";